import React from 'react';
import PropTypes from 'prop-types';
import TextButton from '@spothero/ui/text-button';

const ParkingRestrictions = ({
    hasOnlineCommuterRate,
    hasOversizedFee,
    hasVehicleRestriction,
    onOnlineCommuterRateClick,
    onVehicleRestrictionsClick,
}) => {
    const restrictionMessage =
        hasOversizedFee && hasVehicleRestriction
            ? 'Vehicle restrictions and fees.'
            : hasOversizedFee
            ? 'Oversized fee charged on site.'
            : hasVehicleRestriction
            ? 'Vehicle restrictions apply.'
            : null;

    return (
        <div className="ParkingRestrictions">
            {hasOnlineCommuterRate && (
                <small className="online-commuter-rate">
                    Online Special.&nbsp;
                    <TextButton onClick={onOnlineCommuterRateClick}>
                        Details
                    </TextButton>
                </small>
            )}
            {restrictionMessage && (
                <small className="oversize-fee">
                    {restrictionMessage}&nbsp;
                    <TextButton onClick={onVehicleRestrictionsClick}>
                        Details
                    </TextButton>
                </small>
            )}
        </div>
    );
};

ParkingRestrictions.propTypes = {
    hasOnlineCommuterRate: PropTypes.bool,
    hasOversizedFee: PropTypes.bool,
    hasVehicleRestriction: PropTypes.bool,
    onOnlineCommuterRateClick: PropTypes.func,
    onVehicleRestrictionsClick: PropTypes.func,
};

export default ParkingRestrictions;
